import axios from '../axios-config';

// get products by skus bulk with full data of all products
const getProductsBySku = async (skuBulk, token) => {
  const transformSKus = skuBulk
    ? skuBulk.map((sku) => 'sku=' + sku).join('&')
    : '';
  const config = {
    method: 'get',

    url: '/search/get-products-by-skus?' + transformSKus,
    headers: {
      Authorization: 'bearer ' + token,
    },
  };

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// Get Amasty Related Product By Skus
// used in client side in pdp
// used in client side in add to cart
// used in cart page in get server side props
export const getAmastyProductsBySkus = async (sku, locale) => {
  const config = {
    method: 'get',
    baseURL: process.env.NEXT_PUBLIC_API_BASEURL.replace('v1', 'v2'),
    url: `/customer/amasty_mostviewed_related_products/${locale || 'ar'}?sku=${sku}&limit=15`,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// used in home page in client side
// used in pdp in client side also
// used in add to cart in client side
// used in cart page in client side
// get products by skus with specific response data using selected atteributes
const getProductsBySkuV2 = async (skuBulk, token, selectedAtteributes) => {
  const transformSKus = skuBulk
    ? skuBulk.map((sku) => 'sku=' + sku).join('&')
    : '';

  const config = {
    method: 'get',

    url: '/search/v2/get-products-by-skus?' + transformSKus,
    headers: {
      ...(!!token && { Authorization: 'bearer ' + token }),
    },
  };
  if (selectedAtteributes) {
    const atterbiutes = selectedAtteributes
      .map((select) => 'select=' + select)
      .join('&');
    config.url += `&${atterbiutes}`;
  }
  const req = await axios(config);
  return req;
};

// Get Product By Category
export const getProductsByCategory = async (token, categoryId) => {
  try {
    const req = await axios({
      url: `/search/get-products-by-category?id=${categoryId}`,
      headers: {
        Authorization: 'bearer ' + token,
      },
    });
    return req;
  } catch (error) {
    return error;
  }
};
// get all products
const getAllProducts = async (
  token,
  pageNo = 0,
  pageSize = 9999,
  selectedAtteributes
) => {
  let config = {
    method: 'get',

    url: `search/get-products?pageSize=${pageSize}&pageNo=${pageNo}`,
    headers: {
      Authorization: 'bearer ' + token,
    },
  };
  if (selectedAtteributes) {
    const atterbiutes = selectedAtteributes
      .map((select) => 'select=' + select)
      .join('&');

    config.url += `&${atterbiutes}`;
  }
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getAllProductsReWrite = async (token) => {
  let config = {
    method: 'GET',
    url: `/search/get-products?pageSize=100000&pageNo=0&select=rewrite_url`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const req = await axios(config);
    return { data: req.data, error: null };
  } catch (error) {
    return { data: null, error: error.message };
  }
};

export {
  getProductsBySku,
  getProductsBySkuV2,
  getAllProducts,
  getAllProductsReWrite,
};
